import { Attributes, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';
import { TextConstants } from '../../Common/TextConstants';

@NeoModel
export default class UserGroup extends ModelBase {

    public userGroupId: number = 0;

    @Rules.Required()
    @Attributes.Display("Name")
    @Rules.StringLength(100)
    public userGroupName: string = "";

    public isAdministratorGroup = true;

    // Client only properties / methods

    public addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
        var validCharacters = TextConstants.RegularExpression.Alphanumeric;
        rules.failWhen(c => !validCharacters.test(c.userGroupName), "Please provide a valid alphanumeric user group name")
    }

    public toString() {
        if (this.isNew || !this.userGroupName) {
            return "New user group"
        } else {
            return this.userGroupName;
        }
    }
}